import {isNil} from 'ramda';

import {useListSaleVehiclePhotosByVehicleQuery} from '@dms/api/vehicle';

import {Nullish} from 'shared/web';

import {useVehiclePhotosPermissions} from './useVehiclePhotosPermissions';

export function useVehicleCoverPhoto(vehicleId: string | Nullish) {
  const {canReadVehicleAlbumPhotos} = useVehiclePhotosPermissions({
    vehicleId: vehicleId ?? '',
  });

  const {data: saleVehiclePhotos} = useListSaleVehiclePhotosByVehicleQuery(
    {
      vehicleId: vehicleId ?? '',
    },
    {
      skip: !canReadVehicleAlbumPhotos || isNil(vehicleId),
    }
  );

  const photos = saleVehiclePhotos?.photos ?? [];

  const coverPhoto = photos?.find((photo) => photo.isCoverPhoto);

  return {
    photos,
    coverPhoto,
  };
}
